import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useQuestionnaire() {
    const api = useApi();
    const state = useAppState();
    function getQuestionnaire(id, onSuccess = null) {
        api.GET("/Questionnaires/" + id, (result) => {
            state.questionnaire = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function getQuestionnaireByKey(key, onSuccess = null) {
        const config = getApiConfig();
        getHttpInstance().post(config.api + "/Questionnaires/Searches/" + key, null)
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch((result) => {
            if (result.response.status == 401) {
                api.refreshLogin(() => {
                    getQuestionnaireByKey(key, onSuccess);
                });
            }
        });
    }
    function getQuestionnaireByGuidOrKey(id, onSuccess = null) {
        if (id.match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/)) {
            getQuestionnaire(id, onSuccess);
        }
        else {
            getQuestionnaireByKey(id, (result) => {
                state.questionnaire = result;
                if (onSuccess)
                    onSuccess();
            });
        }
    }
    function getQuestionnaireAnswers(id, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerAnswers", (result) => {
            state.questionnaireAnswers = result;
            if (onSuccess)
                onSuccess(result);
        }, false);
    }
    function saveQuestionnaireAnswer(question, onSuccess = null) {
        const requestBody = [];
        if (!question.question.selectedAnswer) {
            return;
        }
        question.question.selectedAnswer.forEach((selectedAnswer) => {
            const answer = {
                "questionID": question.questionId,
            };
            if (selectedAnswer.answerId) {
                answer.answerID = selectedAnswer.answerId;
            }
            if (selectedAnswer.amount != undefined && selectedAnswer.amount != null) {
                answer.freeAnswer = String(selectedAnswer.amount);
            }
            requestBody.push(answer);
        });
        if (requestBody.length == 0) {
            return;
        }
        const config = getApiConfig();
        getHttpInstance().post(config.api + "/Customers/00000000-0000-0000-0000-000000000000/CustomerAnswers", requestBody)
            .then((result) => {
            if (onSuccess)
                onSuccess(result.data);
        })
            .catch((result) => {
            if (result.response.status == 401) {
                api.refreshLogin(() => {
                    saveQuestionnaireAnswer(question, onSuccess);
                });
            }
        });
    }
    return {
        getQuestionnaire,
        getQuestionnaireByKey,
        getQuestionnaireByGuidOrKey,
        getQuestionnaireAnswers,
        saveQuestionnaireAnswer,
    };
}
